(function cascadiaCartFooter(){

  var CFG = window.cascadiaConfig || {};

  function moneyFmt(cents){
    return '$' + (cents / 100).toFixed(2);
  }

  if(!document.getElementById('cascadia-footer-css')){
    var fst = document.createElement('style');
    fst.id = 'cascadia-footer-css';
    fst.textContent = [
      '#cas-promo-toggle:hover { color: #3d2314; }',
      '#cas-promo-toggle:hover svg[stroke="#c8a24e"] { stroke: #b8923e; }',
      '#cas-promo-chevron.is-open { transform: rotate(180deg); }',
      '#cas-promo-apply:hover { background: #2a1810; }',
      '#cas-promo-input:focus { outline: none; border-color: #c8a24e; background: #fff; }'
    ].join(' ');
    document.head.appendChild(fst);
  }

  // fetch compare-at savings from product API for all items in cart
  function calculateSavings(cart){
    var savingsCents = 0;

    // cart-level discount codes from state
    if(cart.savings && cart.savings.length){
      cart.savings.forEach(function(s){ savingsCents += s.amount; });
    }

    // line-level BOGOS discounts
    if(cart.items){
      cart.items.forEach(function(i){
        (i.discounts || []).forEach(function(d){ savingsCents += d.amount; });
      });
    }

    // fetch compare-at prices from product API
    var handles = [];
    if(cart.items){
      cart.items.forEach(function(i){
        if(i.handle && handles.indexOf(i.handle) === -1) handles.push(i.handle);
      });
    }

    if(!handles.length) return Promise.resolve(savingsCents);

    return Promise.all(handles.map(function(handle){
      return window.cascadiaState.getProduct(handle);
    })).then(function(products){
      products.forEach(function(product){
        if(!product) return;
        product.variants.forEach(function(v){
          if(!v.compare_at_price || v.compare_at_price <= v.price) return;
          var cartItem = cart.items && cart.items.find(function(i){ return i.variant_id === v.id; });
          if(cartItem){
            savingsCents += (v.compare_at_price - v.price) * cartItem.quantity;
          }
        });
      });
      return savingsCents;
    });
  }

  function drawFooter(cart, savingsCents, footer){
    var sig = cart.total + '|' + savingsCents;
    var existing = footer.querySelector('#cas-footer-card');
    if(existing && footer.dataset.casSig === sig) return;
    footer.dataset.casSig = sig;

    // hide all Motion native children
    Array.from(footer.children).forEach(function(el){
      if(el.id === 'cas-footer-card') return;
      el.style.setProperty('display', 'none', 'important');
    });

    if(existing) existing.remove();

    // hide native wallet buttons
    var nativeWallet = document.querySelector('#CartDrawer .additional-checkout-buttons');
    if(nativeWallet) nativeWallet.style.setProperty('display', 'none', 'important');

    var total = cart.total;
    var totalFmt = moneyFmt(total);
    var savingsFmt = savingsCents > 0 ? moneyFmt(savingsCents) : null;
    var originalFmt = savingsCents > 0 ? moneyFmt(total + savingsCents) : null;

    var discountCodes = (cart.raw && cart.raw.discount_codes)
  ? cart.raw.discount_codes.filter(function(d){ return d.applicable; })
  : [];
var discountTag = discountCodes.length
  ? '<span style="display:inline-flex;align-items:center;gap:5px;background:#f0f7f0;border:0.5px solid #c8e0c8;border-radius:8px;padding:3px 6px 3px 8px;font-family:Jost,sans-serif;font-size:11px;font-weight:500;color:#03593A;">'
    + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#03593A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
    + discountCodes[0].code
    + '<button type="button" id="cas-discount-remove" aria-label="Remove discount code" style="background:none;border:none;padding:0;margin-left:2px;cursor:pointer;color:#03593A;display:flex;align-items:center;">'
    + '<svg width="10" height="10" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
    + '</button>'
    + '</span>'
  : '';

var subtotalRight = originalFmt
  ? '<span style="display:flex;align-items:baseline;gap:6px;flex-wrap:wrap;justify-content:flex-end;">'
    + discountTag
    + '<s style="font-size:12px;color:#b5a898;font-weight:400;">' + originalFmt + '</s>'
    + '<span style="font-size:17px;font-weight:600;color:#3d2314;">' + totalFmt + '</span>'
    + '</span>'
  : '<span style="display:flex;align-items:baseline;gap:6px;flex-wrap:wrap;justify-content:flex-end;">'
    + discountTag
    + '<span style="font-size:17px;font-weight:600;color:#3d2314;">' + totalFmt + '</span>'
    + '</span>';

    var savingsLine = savingsFmt
      ? '<p style="font-size:11px;color:#03593A;font-weight:500;margin:0 0 9px;text-align:right;">you\'re saving ' + savingsFmt + '</p>'
      : '';

    var card = document.createElement('div');
    card.id = 'cas-footer-card';
    card.style.padding = '0 0 4px';
    card.style.fontFamily = 'Jost, sans-serif';

    card.innerHTML = [

      (discountCodes.length ? '' :
      '<div style="border-top:0.5px solid #e8e5e0;padding-top:12px;margin-bottom:10px;">' +
        '<button type="button" id="cas-promo-toggle" style="display:flex;align-items:center;gap:6px;background:none;border:none;padding:0;cursor:pointer;font-family:Jost,sans-serif;font-size:11.5px;font-weight:500;color:#6b5c4a;">' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#c8a24e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>' +
          '<span>Have a discount code?</span>' +
          '<svg id="cas-promo-chevron" width="9" height="9" viewBox="0 0 16 16" fill="none" style="transition:transform 0.2s ease;margin-left:1px;" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="#a59a8a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<div id="cas-promo-fields" style="display:none;margin-top:10px;">' +
          '<div style="display:flex;gap:8px;align-items:center;">' +
            '<input type="text" id="cas-promo-input" placeholder="Enter code" autocomplete="off" style="flex:1;min-width:0;border:1px solid #e8e5e0;border-radius:999px;padding:9px 16px;font-family:Jost,sans-serif;font-size:12px;color:#3d2314;background:#faf8f5;">' +
            '<button type="button" id="cas-promo-apply" style="background:#3d2314;color:#faf8f5;border:none;border-radius:999px;padding:9px 18px;font-family:Jost,sans-serif;font-size:12px;font-weight:500;cursor:pointer;white-space:nowrap;">Apply</button>' +
          '</div>' +
          '<p id="cas-promo-msg" style="font-size:11px;margin:7px 2px 0;display:none;"></p>' +
        '</div>' +
      '</div>'),

      '<div style="border-top:0.5px solid #e8e5e0;padding-top:8px;">',
        '<div style="display:flex;align-items:baseline;justify-content:space-between;margin-bottom:' + (savingsFmt ? '2px' : '9px') + ';">',
          '<span style="font-family:Cormorant Garamond,Georgia,serif;font-style:italic;font-size:17px;color:#3d2314;font-weight:400;">Subtotal</span>',
          subtotalRight,
        '</div>',
        savingsLine,
      '</div>',

      '<p style="font-size:14px;color:#6b5c4a;text-align:center;margin:8px 0 7px;">Continue to shipping & taxes :)</p>',

      '<button id="cas-checkout-btn" type="button" style="width:100%;background:#1a3d2b;color:#fff;border:none;border-radius:999px;padding:12px 18px;display:flex;align-items:center;justify-content:center;gap:8px;cursor:pointer;font-family:Jost,sans-serif;font-size:14px;font-weight:600;letter-spacing:0.03em;margin-bottom:6px;box-shadow:0 2px 16px rgba(26,61,43,0.3),inset 0 1px 0 rgba(200,162,78,0.25),inset 0 -1px 0 rgba(0,0,0,0.15);box-sizing:border-box;">',
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>',
        '<span>Checkout · ' + totalFmt + '</span>',
      '</button>',

      '<div id="cas-wallet-slot"></div>'

    ].join('');

    footer.appendChild(card);

    // checkout — direct to /checkout, bypasses cart form
    card.querySelector('#cas-checkout-btn').addEventListener('click', function(){
      window.location.href = '/checkout';
    });

    // discount field
    var promoToggle = card.querySelector('#cas-promo-toggle');
    var promoFields = card.querySelector('#cas-promo-fields');
    if(promoToggle && promoFields){
      promoToggle.addEventListener('click', function(){
        var isOpen = promoFields.style.display !== 'none';
        promoFields.style.display = isOpen ? 'none' : 'block';
        var chevron = card.querySelector('#cas-promo-chevron');
        if(chevron) chevron.classList.toggle('is-open', !isOpen);
        if(!isOpen){
          var input = card.querySelector('#cas-promo-input');
          if(input) input.focus();
        }
      });
    }

    var promoApply = card.querySelector('#cas-promo-apply');
    var promoInput = card.querySelector('#cas-promo-input');
    var promoMsg = card.querySelector('#cas-promo-msg');

    function setPromoMsg(text, isError){
      if(!promoMsg) return;
      promoMsg.textContent = text;
      promoMsg.style.color = isError ? '#a33333' : '#03593A';
      promoMsg.style.display = text ? 'block' : 'none';
    }

    if(promoApply && promoInput){
      promoApply.addEventListener('click', function(){
        var code = promoInput.value.trim();
        if(!code) return;
        promoApply.disabled = true;
        promoApply.textContent = 'Applying…';
        setPromoMsg('', false);

        window.cascadiaState.applyDiscount(code).then(function(){
          return fetch('/cart.js').then(function(r){ return r.json(); });
        }).then(function(freshCart){
          var codes = freshCart.discount_codes || [];
          var match = codes.find(function(d){ return d.code.toLowerCase() === code.toLowerCase(); });
          promoApply.disabled = false;
          promoApply.textContent = 'Apply';
          if(match && match.applicable){
            promoInput.value = '';
            document.dispatchEvent(new CustomEvent('cascadia:cart-changed'));
          } else if(match && !match.applicable){
            setPromoMsg('That code doesn\'t apply to your cart right now.', true);
          } else {
            setPromoMsg('That code isn\'t valid.', true);
          }
        }).catch(function(){
          promoApply.disabled = false;
          promoApply.textContent = 'Apply';
          setPromoMsg('Something went wrong — try again.', true);
        });
      });

      promoInput.addEventListener('keydown', function(e){
        if(e.key === 'Enter'){
          e.preventDefault();
          promoApply.click();
        }
      });
    }

    var promoRemove = card.querySelector('#cas-discount-remove');
    if(promoRemove){
      promoRemove.addEventListener('click', function(){
        promoRemove.disabled = true;
        window.cascadiaState.applyDiscount('').then(function(){
          document.dispatchEvent(new CustomEvent('cascadia:cart-changed'));
        }).catch(function(){
          promoRemove.disabled = false;
        });
      });
    }

    // decorative wallet line
    var walletSlot = card.querySelector('#cas-wallet-slot');
    var walletLine = document.createElement('p');
    walletLine.style.cssText = 'font-size:10px;color:#b5a898;text-align:center;margin:0 0 4px;letter-spacing:0.02em;';
    walletLine.innerHTML = 'Also accepts <span style="color:#5a31f4;font-weight:600;">Shop Pay</span> · <span style="color:#003087;font-weight:600;">PayPal</span> · <span style="color:#3c3c3c;font-weight:500;">G Pay</span>';
    walletSlot.appendChild(walletLine);
  }

  function render(cart){
  var isDrawer = !document.querySelector('#CartPageForm');
  var footer = isDrawer
    ? document.querySelector('#CartDrawer .drawer__footer')
    : document.querySelector('#CartPageForm .cart__footer');
  if(!footer) return;

    calculateSavings(cart).then(function(savingsCents){
      drawFooter(cart, savingsCents, footer);
    });
  }

  window.cascadiaFooter = { render: render };
  console.log('[cascadia footer] ready');

})();